module.exports = __webpack_public_path__ + "static/Privacy-Policy-6646f5cbe347b813a7963babd9f8fdec.jpg";